<template>
  <div class="container column-container">
    <img :src="getImage(error)" alt="error" />
    <div class="mensaje-wrapper">
      <p class="titulo medium">{{ error.title }}</p>
      <span>
        <p>{{ error.subtitle }}</p>
      </span>
    </div>

    <div class="button-container">
      <sales-button
        @click.native="$router.go(-1)"
        class="sales-button"
        label="Volver"
      />
    </div>
    <help />
  </div>
</template>

<script>
import errores from "@/config/constants/errores";
import SalesButton from "@/components/core/SalesButton";
import Help from "@/components/core/Help";

export default {
  name: "Mensaje",
  components: { SalesButton, Help },
  methods: {
    getImage(error) {
      return require("@/assets/img/1x/" + error.img);
    }
  },
  computed: {
    error() {
      return errores[this.$route.params.mje];
    }
  }
};
</script>

<style scoped>
img {
  width: 140px;
  display: block;
}

.column-container {
  max-width: 640px;
  padding-top: 40px;
}

div.sales-button {
  width: 212px;
  height: 56px;
}

p.titulo {
  line-height: 1.2em;
  font-size: 28px;
  margin-bottom: 0;
}

div.mensaje-wrapper {
  color: #121212;
  font-size: 18px;
  margin-top: 40px;
  margin-bottom: 42px;
}

div.button-container {
  text-align: left;
}
</style>
